import * as ActionTypes from '../actions';

const clearedSession = {
  loggedIn: false,
  candidateJwt: '',
  candidateIds: [],
};

export const initialState = {
  checkedAuth: false,
  processing: false,
  loggedIn: false,
  loggedOut: false,
  submitError: false,
  candidateEmail: '',
  candidateJwt: '',
  errorMessage: '',
  candidateIds: [],
  authMethod: null,
  workosStep: 'email',
  workosError: null,
};

const candidateLogin = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.FETCH_REPORTS_SUCCESS:
      if (!action.email) return state;
      return {
        ...state,
        candidateEmail: action.email,
      };
    case ActionTypes.CHECK_FOR_ACTIVE_AUTH:
      return {
        ...state,
        processing: true,
      };
    case ActionTypes.CHECK_FOR_ACTIVE_AUTH_COMPLETE:
      // Don't let a stale session check overwrite a successful login.
      // The OAuth callback route lives outside Layout to avoid the race
      // structurally, but this guard protects against any future path
      // where both fire concurrently.
      if (state.loggedIn && !payload.loggedIn) {
        return { ...state, checkedAuth: true, processing: false };
      }
      return {
        ...state,
        checkedAuth: true,
        candidateJwt: payload.candidateJwt,
        loggedIn: payload.loggedIn,
        candidateIds: payload.candidateIds,
        authMethod: payload.authMethod || null,
        processing: false,
      };
    case ActionTypes.FETCH_REPORTS_FAILURE:
      return {
        ...state,
        ...clearedSession,
        errorMessage: 'notFound',
      };
    case ActionTypes.FETCH_REPORTS_UNKNOWN_FAILURE:
      return {
        ...state,
        ...clearedSession,
        errorMessage: 'unknownFailure',
      };
    // Same logout reset as the other report-fetch failures. INTL is only
    // reachable from the international login form (already logged out there),
    // but FETCH_REPORTS_BUSY is reachable from the authenticated
    // candidateIds/JWT path on a 5xx — without this, loggedIn stays true and
    // re-creates the redirect loop on a server error. portal.error already
    // carries the user-facing message for both, so no errorMessage here.
    case ActionTypes.FETCH_REPORTS_FAILURE_INTL:
    case ActionTypes.FETCH_REPORTS_BUSY:
      return {
        ...state,
        ...clearedSession,
      };
    case ActionTypes.CLEAR_FETCH_REPORTS_FAILURE:
      return {
        ...initialState,
        checkedAuth: true,
      };
    case ActionTypes.LOGOUT_CANDIDATE:
      return {
        ...state,
        ...initialState,
        checkedAuth: true,
      };
    case ActionTypes.WORKOS_RESET:
      return {
        ...state,
        workosStep: 'email',
        workosError: null,
        processing: false,
      };
    case ActionTypes.WORKOS_MAGIC_CODE_SENDING:
      return {
        ...state,
        processing: true,
        workosError: null,
      };
    case ActionTypes.WORKOS_MAGIC_CODE_SENT:
      return {
        ...state,
        processing: false,
        workosStep: 'code',
        candidateEmail: payload.email,
        workosError: null,
      };
    case ActionTypes.WORKOS_VERIFY_REQUEST:
      return {
        ...state,
        processing: true,
        workosError: null,
      };
    case ActionTypes.WORKOS_VERIFY_SUCCESS:
      return {
        ...state,
        processing: false,
        loggedIn: true,
        loggedOut: false,
        candidateJwt: payload.candidateJwt,
        candidateIds: payload.candidateIds,
        authMethod: payload.authMethod,
        workosError: null,
        submitError: false,
        errorMessage: '',
      };
    case ActionTypes.WORKOS_VERIFY_FAILURE:
      return {
        ...state,
        processing: false,
        workosError: payload.error,
      };
    case ActionTypes.WORKOS_DOB_REQUIRED:
      return {
        ...state,
        processing: false,
        workosStep: 'dob',
        workosError: null,
      };
    default:
      return state;
  }
};

export default candidateLogin;
